export const RecurringTaskType = {
	month: 1,
	week: 2,
	day: 3,
	year: 4,
};